<template>
  <SalesDashboardCard title="Books (source)" class-card="col-md-4" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
    <div slot="body">
      <Loader v-if="loading" />
      <div v-else-if="sources && sources.length > 0" class="d-flex align-items-center justify-content-center flex-wrap">
        <div class="">
          <BooksSourceChart :sources="sources" />
        </div>
      </div>
      <div v-else>
        <p class="text-center">There are no jobs.</p>
      </div>
    </div>
  </SalesDashboardCard>
</template>

<script>
import axios from 'axios';
import moment from 'moment/moment';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';
import BooksSourceChart from './BooksSource/BooksSourceChart';

const filters = [
  {
    name: 'Today',
    date: '',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
  },
  {
    name: 'Yesterday',
    date: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    from: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'This week',
    date: '',
    from: moment()
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .weekday(7)
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last week',
    date: '',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
  },
  {
    name: 'This month',
    date: '',
    from: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .endOf('month')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last month',
    date: '',
    from: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD'),
  },
];

export default {
  components: { BooksSourceChart, Loader, SalesDashboardCard },
  data() {
    return {
      loading: false,
      sources: [],
      colors: [
        '#FF766A',
        '#FFCC91',
        '#2979FF',
        '#B7FFB1',
        '#FF88B4',
        '#FF9900',
        '#5968AD',
        '#97A5EB',
      ],
      filters,
      selectedFilter: filters[0],
    };
  },
  watch: {
    selectedFilter() {
      this.getSources();
    },
  },
  mounted() {
    this.getSources();
  },
  methods: {
    getSources() {
      this.loading = true;
      axios
        .get(
          `/sales/count-jobs/sources?date=${this.selectedFilter.date}&date_from=${
            this.selectedFilter.from
          }&date_to=${this.selectedFilter.to}`,
        )
        .then(res => {
          this.sources = res.data.data.map((source, index) => {
            source.color = this.colors[index];
            return source;
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/BooksSource.vue